"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _Cart = babelHelpers.interopRequireDefault(require("Cart"));

var _noty = require("noty");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

var Channel = _exports.default.Channel,
    Session = _exports.default.Session;
var ProductCard = (_class = (_temp =
/*#__PURE__*/
function (_Card) {
  babelHelpers.inherits(ProductCard, _Card);

  function ProductCard() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, ProductCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(ProductCard)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "isProductsPage", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "linkTarget", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "priceInfo", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "quantity", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = Object.assign(babelHelpers.get(babelHelpers.getPrototypeOf(ProductCard.prototype), "state", babelHelpers.assertThisInitialized(_this)) || {}, {
      inputQuantity: null
    });
    return _this;
  }

  babelHelpers.createClass(ProductCard, [{
    key: "renderImage",
    value: function renderImage() {
      if (this.isProductsPage) {
        return _react.default.createElement("a", {
          href: this.linkTarget,
          className: "image",
          style: {
            backgroundImage: "url(".concat(this.scaleImage ? "/t/width=400/matte=none/scale/f".concat(this.image, "/image.jpg") : this.image, ")")
          }
        });
      }

      return babelHelpers.get(babelHelpers.getPrototypeOf(ProductCard.prototype), "renderImage", this).call(this);
    }
  }, {
    key: "renderTileBody",
    value: function renderTileBody() {
      if (this.isProductsPage) {
        return _react.default.createElement(_react.Fragment, null, _react.default.createElement("a", {
          href: this.linkTarget
        }, _react.default.createElement("h3", null, this.objectTitle)), this.promoText && this.objectListingSummary != this.promoText ? _react.default.createElement("p", {
          className: "promoText"
        }, this.promoText) : null, this.objectListingSummary ? _react.default.createElement("p", {
          className: this.objectListingClasses
        }, this.objectListingSummary) : null);
      }

      return babelHelpers.get(babelHelpers.getPrototypeOf(ProductCard.prototype), "renderTileBody", this).call(this);
    }
  }, {
    key: "getItemPriceText",
    value: function getItemPriceText() {
      var _this$priceInfo = this.priceInfo,
          basePrice = _this$priceInfo.basePrice,
          salePrice = _this$priceInfo.salePrice;
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement("span", {
        className: "basePrice".concat(basePrice != salePrice ? ' strike' : '')
      }, this.formatPrice(basePrice)), basePrice != salePrice ? _react.default.createElement("span", {
        className: "salePrice"
      }, this.formatPrice(salePrice)) : null);
    }
  }, {
    key: "formatPrice",
    value: function formatPrice(amount) {
      amount = Number(amount).toFixed(2);

      var _amount$split = amount.split('.'),
          _amount$split2 = babelHelpers.slicedToArray(_amount$split, 2),
          whole = _amount$split2[0],
          dec = _amount$split2[1];

      var dd = '';

      while (whole.length > 3) {
        dd = ",".concat(whole.substr(-3));
        whole = whole.substring(0, whole.length - 3);
      }

      dd = whole + dd;
      return "$".concat(dd, ".").concat(dec);
    }
  }, {
    key: "setQuantity",
    value: function setQuantity(event) {
      this.setState({
        inputQuantity: Number(event.target.value)
      });
    }
  }, {
    key: "renderAdditionalTileContents",
    value: function renderAdditionalTileContents() {
      if (this.isProductsPage) {
        return _react.default.createElement("form", {
          className: "product-form bottom",
          onSubmit: this.addToCart
        }, _react.default.createElement("input", {
          type: "hidden",
          name: "id",
          value: this.id
        }), _react.default.createElement("div", {
          className: "price"
        }, this.getItemPriceText()), _react.default.createElement("input", {
          type: "number",
          name: "quantity",
          value: this.state.inputQuantity === null ? this.quantity : this.state.inputQuantity,
          onChange: this.setQuantity,
          className: "form-control quantity"
        }), _react.default.createElement("div", {
          className: "total"
        }, _react.default.createElement("button", {
          className: "btn btn-default",
          type: "submit"
        }, "Add")));
      }

      return babelHelpers.get(babelHelpers.getPrototypeOf(ProductCard.prototype), "renderAdditionalTileContents", this).call(this);
    }
  }, {
    key: "addToCart",
    value: function addToCart(event) {
      var _this2 = this;

      event.preventDefault();
      (0, _fetch.default)('data/cart/add', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          product: this.id,
          quantity: this.state.inputQuantity === null ? this.quantity : this.state.inputQuantity
        })
      }).then(function (data) {
        return data.json();
      }).then(function (data) {
        if (data.ok) {
          _Cart.default.updateCart();

          (0, _noty.showNotification)({
            text: "Added product to cart.",
            id: "addedProduct",
            count: 1,
            update: function update(options) {
              this.count += options.count;
              return "Added " + this.count + " products to cart.";
            }
          });

          _this2.setState({
            inputQuantity: null
          });
        }
      });
    }
  }]);
  return ProductCard;
}(_base.default), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "isProductsPage", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "linkTarget", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "priceInfo", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "quantity", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "setQuantity", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setQuantity"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "addToCart", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "addToCart"), _class.prototype)), _class);
exports.default = ProductCard;